var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.link)?_c('button',{class:_vm.mode},[_vm._t("default")],2):_c('router-link',{class:_vm.mode,attrs:{"to":_vm.to}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }